import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import * as classnames from 'classnames';
import { isNil, find } from 'lodash';
import { setCarouselSelectedStimuliId } from '../../data/analysis/stimuliActions';

class StimuliCarousel extends Component {
  constructor(props) {
    super(props);

    this.setActiveStimuli = this.setActiveStimuli.bind(this);
  }

  setActiveStimuli(stimuliId) {
    this.props.dispatch(setCarouselSelectedStimuliId(stimuliId));
  }

  render() {
    const self = this;

    const stimuliThumbnails = this.props.stimuli.map(stimuli => {
      const thumbnailClasses = classnames({
        selected: stimuli.id === self.props.selectedStimuliId,
        thumbnail: true,
        hasData: !isNil(find(self.props.heatmaps, { stimuliId: stimuli.id }))
      });

      return (
        <div
          key={stimuli.id}
          className={thumbnailClasses}
          onClick={() => {
            this.setActiveStimuli(stimuli.id);
          }}
        >
          <img src={stimuli.thumbnail_url} alt={stimuli.name} />
        </div>
      );
    });

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column className="stimuliCarouselContainer">
            <div className="stimuliCarousel">{stimuliThumbnails}</div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default connect(state => ({
  stimuli: state.analysis.single.stimuli,
  selectedStimuliId: state.analysis.single.selectedStimuliId,
  heatmaps: state.analysis.data.heatmaps
}))(StimuliCarousel);



// WEBPACK FOOTER //
// ./src/scenes/analysis/components/analysis/StimuliCarousel.js